import { Controller } from "@hotwired/stimulus";
import {
  initUxTracking,
  teardownUxTracking,
  bindInteractionListeners,
  unbindInteractionListeners,
  scanImpressions,
} from "../utils/ux_event_tracker";

// Mounts UX event tracking (button usage, blocked states, JS/AJAX errors)
// scoped to whichever online-ordering layout root renders this controller —
// see app/javascript/utils/ux_event_tracker.js for the batching/transport
// logic. Reconnects per Turbolinks page visit, so init/teardown are
// symmetric rather than one-time.
export default class extends Controller {
  static values = { endpoint: String, layout: String };

  connect() {
    initUxTracking({ endpoint: this.endpointValue, layout: this.layoutValue });
    bindInteractionListeners(this.element);
    scanImpressions(this.element);
  }

  disconnect() {
    unbindInteractionListeners(this.element);
    teardownUxTracking();
  }
}
